import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, Radio, RadioGroup, Stack, Switch, ThemeProvider, Typography } from '@mui/material';
import { createTheme } from '@mui/material';
export const theme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: 12,
                    padding: 10,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: 0,
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 12,
                    color: 'GrayText',
                },
            },
        },
        MuiStack: {
            styleOverrides: {
                root: {
                    margin: 0,
                    padding: 0,
                },
            },
        },
    },
});
/** return switch approximately same size and font as TextInput with label */
export const BinaryChoiceSwitch = ({ onChange, valueA, valueB, currentValue, isValueA }) => {
    const isA = isValueA(currentValue);
    return (_jsx(ThemeProvider, { theme, children: _jsxs(Stack, { direction: 'column', alignItems: 'center', spacing: -0.5, children: [_jsxs(Typography, { children: [_jsx("span", { style: { textDecoration: !isA ? 'underline' : undefined }, children: valueB }), _jsx("span", { children: "/" }), _jsx("span", { style: { textDecoration: isA ? 'underline' : undefined }, children: valueA })] }), _jsx(Switch, { checked: isA,
                    onChange,
                    size: 'small',
                    sx: {} })] }) }));
};
const commonRadioProps = { size: 'small', sx: { padding: 0, marginInline: 1 } };
const commonLabelProps = { sx: { margin: 0 } };
/** return 2 button stack Radio approximately same size and font as TextInput with label */
export const BinaryChoiceRadio = ({ onChange, valueA, valueB, labelA, labelB, currentValue, disabled = false }) => {
    return (_jsx(ThemeProvider, { theme, children: _jsx(Stack, { direction: 'column', alignItems: 'center', children: _jsxs(RadioGroup, { value: currentValue, onChange, children: [_jsx(FormControlLabel, { disabled, ...commonLabelProps, control: _jsx(Radio, { ...commonRadioProps }), label: labelA ?? valueA, value: valueA }), _jsx(FormControlLabel, { disabled, ...commonLabelProps, control: _jsx(Radio, { ...commonRadioProps }), label: labelB ?? valueB, value: valueB })] }) }) }));
};
